<div class="loader" *ngIf="loaderService.isBusy" class="overlay">
  <img class="spinner" src="/assets/loaders/loader.svg" alt="" />
</div>
